import { render, staticRenderFns } from "./EditServices.vue?vue&type=template&id=6b419b05&scoped=true&"
import script from "./EditServices.vue?vue&type=script&lang=js&"
export * from "./EditServices.vue?vue&type=script&lang=js&"
import style0 from "./EditServices.vue?vue&type=style&index=0&id=6b419b05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b419b05",
  null
  
)

export default component.exports